import React from "react";
import TimerPage from "../../components/TimerPage";

const Stage2: React.FC = () => (
  <TimerPage title="2.一对一攻辩" initialTime={90} />
);

export default Stage2;
